/** @format */

import { tokens } from '../tokens';

export const en = {
  [tokens.common.languageChanged]: 'Language changed',
  [tokens.nav.academy]: 'Academy',
  [tokens.nav.account]: 'Account',
  [tokens.nav.analytics]: 'Analytics',
  [tokens.nav.auth]: 'Auth',
  [tokens.nav.blog]: 'Blog',
  [tokens.nav.browse]: 'Browse',
  [tokens.nav.calendar]: 'Calendar',
  [tokens.nav.chat]: 'Chat',
  [tokens.nav.checkout]: 'Checkout',
  [tokens.nav.concepts]: 'Concepts',
  [tokens.nav.contact]: 'Contact',
  [tokens.nav.course]: 'Course',
  [tokens.nav.create]: 'Create',
  [tokens.nav.crypto]: 'Crypto',
  [tokens.nav.customers]: 'Customers',
  [tokens.nav.dashboard]: 'Dashboard',
  [tokens.nav.details]: 'Details',
  [tokens.nav.ecommerce]: 'E-Commerce',
  [tokens.nav.edit]: 'Edit',
  [tokens.nav.error]: 'Error',
  [tokens.nav.feed]: 'Feed',
  [tokens.nav.fileManager]: 'File Manager',
  [tokens.nav.finance]: 'Finance',
  [tokens.nav.fleet]: 'Fleet',
  [tokens.nav.forgotPassword]: 'Forgot Password',
  [tokens.nav.invoiceList]: 'Invoices',
  [tokens.nav.jobList]: 'Job Listings',
  [tokens.nav.kanban]: 'Kanban',
  [tokens.nav.list]: 'List',
  [tokens.nav.login]: 'Login',
  [tokens.nav.logistics]: 'Logistics',
  [tokens.nav.mail]: 'Mail',
  [tokens.nav.management]: 'Quản lý',
  [tokens.nav.managementOverview]: 'Tổng quan',
  [tokens.nav.managementAnalytic]: 'Thống kê',
  [tokens.nav.managementSchedule]: 'Lịch trình',
  [tokens.nav.managementCar]: 'Thông tin xe',
  [tokens.nav.managementDashboard]: 'Dashboard',
  [tokens.nav.managementControl]: 'Control',
  [tokens.nav.managementEvent]: 'Event',
  [tokens.nav.managementDiagnostic]: 'Diagnostic',
  [tokens.nav.managementReport]: 'Report',
  [tokens.nav.managementAlarm]: 'Alarm',

  [tokens.nav.booking]: 'Đặt xe',

  [tokens.nav.configuration]: 'Cài đặt',
  [tokens.nav.configurationCostBasic]: 'Phí cơ bản',
  [tokens.nav.configurationCostOperating]: 'Phí chuyến đi',
  [tokens.nav.configurationCarBrand]: 'Hãng xe',
  [tokens.nav.configurationCarModel]: 'Mẫu xe',
  [tokens.nav.configurationCarFeature]: 'Tính năng trên xe',
  [tokens.nav.configurationCarSpecification]: 'Thông số kĩ thuật',

  [tokens.nav.administrator]: 'Administrator',
  [tokens.nav.managementCustomer]: 'Customer Management',
  [tokens.nav.managementUser]: 'Tài khoản',
  [tokens.nav.orderList]: 'Orders',
  [tokens.nav.overview]: 'Overview',
  [tokens.nav.pages]: 'Pages',
  [tokens.nav.postCreate]: 'Post Create',
  [tokens.nav.postDetails]: 'Post Details',
  [tokens.nav.postList]: 'Post List',
  [tokens.nav.pricing]: 'Pricing',
  [tokens.nav.productList]: 'Products',
  [tokens.nav.profile]: 'Profile',
  [tokens.nav.register]: 'Register',
  [tokens.nav.resetPassword]: 'Reset Password',
  [tokens.nav.socialMedia]: 'Social Media',
  [tokens.nav.verifyCode]: 'Verify Code',
  [tokens.message.validate.isExist]: '{{field}} already exists.',
  [tokens.message.confirmDelete]: `Bạn có chắc chắn muốn xoá {{field}} !!!`,
  [tokens.message.confirmChangeActive]: 'Bạn chắc chắn muốn {{action}} {{field}}?',
  [tokens.message.createFailed]: 'Failed to create {{doc}}!',
  [tokens.message.updateFailed]: 'Failed to update {{doc}}!'
};
